module.exports = __webpack_public_path__ + "img/Cookie_1_resize_03.86de32d3.png";